/**
 * The default data for the Update Member Email Form component.
 */
export const defaultUpdateMemberEmailFormData = {
    email: '',
    currentPassword: '',
    captcha: undefined
};
//# sourceMappingURL=data.js.map